import { Stack } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../../hooks';
import { getGenerationId } from '../../../../store/GenerationSlice';
import { AppDispatch, RootState } from '../../../../store/store';
import { Mode } from '../../../../types/common';
import { BaseForm, FormInput } from '../../../UI';

const INIT_INPUT = {
  category_name: '',
};

const VALIDATE_FIELDS = ['category_name'];

interface ICategoryFormProps {}

const CategoryForm: React.FC<ICategoryFormProps> = () => {
  const { input, error, handleChange, submit, resetForm, tags, handleAddTag, handleDeleteTag, handlePressKey } =
    useForm(INIT_INPUT, handleSubmit, VALIDATE_FIELDS);
  const { isGenerationLoading, isHistoryLoading } = useSelector((state: RootState) => state.generation);
  const dispatch = useDispatch<AppDispatch>();

  function handleSubmit() {
    dispatch(getGenerationId({ ...input, tags, mode: Mode.ProductCategory }));
  }

  return (
    <BaseForm onSubmit={submit} onReset={resetForm}>
      <Stack gap={'20px'}>
        <FormInput
          onChange={handleChange}
          error={error?.category_name || ''}
          name={'category_name'}
          value={input.category_name || ''}
          placeholder={'Например, зимние шины'}
          label={'Категория'}
          maxLength={350}
          required
        />

        <FormInput
          onChange={handleChange}
          onAddTag={handleAddTag}
          onDeleteTag={handleDeleteTag}
          onKeyPress={handlePressKey}
          name={'tags'}
          value={input.tags || ''}
          placeholder={'Например, купить зимние шины'}
          label={'Ключевые слова'}
          tags={tags}
          disabled={isGenerationLoading || isHistoryLoading}
          maxLength={30}
        />
      </Stack>
    </BaseForm>
  );
};

export default CategoryForm;
